import contactsApi from "./contacts-api";


let constructorsApi = {
    ...contactsApi('constructors', ['phones','addresses','labels'])
}

export default constructorsApi